import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';
import { useProfileQuery } from '@/features/profile/api/profile';
import { useStopImpersonation } from '../api/impersonation';

export function ImpersonationBanner() {
  const { data } = useProfileQuery();
  const navigate = useNavigate();
  const stop = useStopImpersonation();

  if (!data?.impersonatedBy) return null;

  const onStop = () => {
    stop.mutate(undefined, { onSuccess: () => void navigate('/') });
  };

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-between gap-2 border-b bg-warning px-4 py-2 text-sm text-warning-foreground"
    >
      <span className="min-w-0">
        Viewing as <strong className="font-semibold">{data.email}</strong>. Everything you do is
        recorded against your admin account.
      </span>
      <Button type="button" size="sm" variant="outline" disabled={stop.isPending} onClick={onStop}>
        {stop.isPending ? 'Stopping…' : 'Stop impersonating'}
      </Button>
    </div>
  );
}
